<template>
  <component
    :is="errorWithDefaultImg ? 'div' : 'img'"
    :src="!errorWithDefaultImg ? srcToUse : undefined"
    :key="srcToUse"
    @error="onError"
    :class="{
      '!object-contain': useFallback,
      shimmerElement: errorWithDefaultImg,
    }"
  />
</template>

<script>
import { defineComponent } from 'vue'
import defaultImg from './sample.svg'
import ImageFiles from '@/shared/utils/imageFiles'

export default defineComponent({
  name: 'ImgComponent',
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, default: '' },
    avatar: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultImg,
      hasError: false,
      errorWithDefaultImg: false,
      triedReceivedFallback: false, // pour ne pas boucler sur fallback
    }
  },
  methods: {
    onError() {
      if (!this.hasError) {
        this.hasError = true
      } else if (this.fallback && !this.triedReceivedFallback) {
        this.triedReceivedFallback = true
      } else if (this.useFallback && this.srcToUse === this.defaultImg) {
        this.errorWithDefaultImg = true
        console.warn(
          `[ImgComponent] Fallback échoué, utilisation de l'image par défaut.`,
        )
      }
    },

    resolveSrc(rawSrc) {
      if (!rawSrc) return ''
      if (/^(https?:\/\/|data:image)/.test(rawSrc)) return rawSrc

      const bundled = ImageFiles.get(rawSrc)
      if (bundled) return bundled

      if (/^(\/|\.\/|\.\.\/)/.test(rawSrc)) return rawSrc

      console.warn(`[ImgComponent] Source inconnue: "${rawSrc}"`)
      return ''
    },
  },
  computed: {
    useFallback() {
      return this.hasError || !this.src
    },
    defaultAvatar() {
      return `https://api.dicebear.com/7.x/avataaars/svg?seed=${this.src || Date.now()}.svg`
    },
    computedFallback() {
      // Priorité : prop fallback → avatar → defaultImg
      if (!this.triedReceivedFallback && this.fallback) return this.fallback
      return this.avatar ? this.defaultAvatar : this.defaultImg
    },
    srcToUse() {
      const base = this.useFallback ? this.computedFallback : this.src
      return this.resolveSrc(base)
    },
  },
  watch: {
    srcToUse: {
      immediate: true,
      handler(newVal) {
        this.$emit('pictureUrlSelected', newVal)
      },
    },
  },
})
</script>
